import { isSSR } from '@/utils/millesimaUtils';

export class LocalStorageService {
  static get storage() {
    if (isSSR()) {
      return {
        setItem: (_key: string, _value: string) => undefined,
        getItem: (_key: string): string => '',
        removeItem: (_key: string) => undefined
      };
    }
    return window.localStorage;
  }

  static set(key: string, str: string): void {
    LocalStorageService.storage.setItem(key, str);
  }

  static get(key: string): string | undefined {
    return LocalStorageService.storage.getItem(key);
  }

  static setObject<T>(key: string, item: T): void {
    LocalStorageService.storage.setItem(key, JSON.stringify(item));
  }

  static getObject<T>(key: string): T | undefined {
    try {
      const item = LocalStorageService.storage.getItem(key);
      return JSON.parse(item) as T;
    } catch {
      return undefined;
    }
  }

  static remove(key: string): void {
    LocalStorageService.storage.removeItem(key);
  }
}
